var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSchedule(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.37 20.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n        stroke: #667085;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        stroke-width: 2px;\n      }\n\n      .cls-3 {\n        stroke-width: 1.75px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.1,
    y1: 6.08,
    x2: 13.95,
    y2: 6.08
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.78,
    y1: 1,
    x2: 4.78,
    y2: 4.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 10.26,
    y1: 1,
    x2: 10.26,
    y2: 4.19
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m8.43,14.64c0-2.5,2.02-4.52,4.52-4.52.43,0,.83.08,1.22.19v-5.56c0-1.1-.9-2-2-2H2.88c-1.1,0-2,.9-2,2v8.89c0,1.1.9,2,2,2h5.67c-.07-.32-.12-.66-.12-1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 12.98,
    cy: 14.64,
    r: 4.52
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "12.77 12.46 12.77 15.02 15.12 15.02"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSchedule);
export default __webpack_public_path__ + "static/media/icon_schedule.38986be21f25c2c1cfda0620256b482f.svg";
export { ForwardRef as ReactComponent };